import { Company, Organisation } from '@/organisations/models';


export class AnnualReportPrompt {
    id?: number;
    title?: string;
    prompt?: string;
    organisationId?: number;

    deserialize(data: any) {
        this.id = data.id ?? undefined;
        this.title = data.title ?? undefined;
        this.prompt = data.prompt ?? undefined;
        this.organisationId = data.organisation_id ?? undefined;
        return this;
    }
}
